import React from 'react';
import { Route, Switch } from '@okapi/router-react';
import { memo } from 'common/hocs';
import { patchPath } from 'utils/patch-path';
import { PDPConnected } from './product-details';

const Routes = memo(function Routes() {
  const paths = ['/product/:productDescriptor', '/set/:productDescriptor'].flatMap(patchPath);
  return (
    <Switch>
      <Route path={paths}>
        <PDPConnected />
      </Route>
    </Switch>
  );
});

export { Routes };
